import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LogginComponent } from './pages/loggin/loggin.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { OffersComponent } from './pages/offers/offers/offers.component';
import { OffersAddComponent } from './pages/offers/offers-add/offers-add.component';
import { UserComponent } from './pages/user/user/user.component';
import { UserAddComponent } from './pages/user/user-add/user-add.component';
import { EmployComponent } from './pages/employ/employ/employ.component';
import { PositionsComponent } from './pages/positions/positions/positions.component';
import { AreasComponent } from './pages/areas/areas/areas.component';
import { DivisionsComponent } from './pages/divisions/divisions/divisions.component';
import { ParametersComponent } from './pages/parameters/parameters/parameters.component';
import { BenefitsComponent } from './pages/benefits/benefits/benefits.component';
import { SignaturesComponent } from './pages/signatures/signatures/signatures.component';
import { PasswordResetComponent } from './pages/password/password-reset/password-reset.component';
import { PasswordRecoveryComponent } from './pages/password/password-recovery/password-recovery.component';
import { EmployUploadComponent } from './pages/employ/employ-upload/employ-upload.component';
import { CompaniesComponent } from './pages/companies/companies/companies.component';
import { SignaturEditComponent } from './pages/signatures/signatur-edit/signatur-edit.component';
import { RequestedSignaturesComponent } from './pages/requested-signatures/requested-signatures/requested-signatures.component';
import { ReviewRequestedSignaturesComponent } from './pages/requested-signatures/review-requested-signatures/review-requested-signatures.component';
import { BudgetCalculationComponent } from './pages/budget-calculation/budget-calculation/budget-calculation.component';
import { HolidaysEditComponent } from './pages/holidays/holidays-edit/holidays-edit.component';
import { HolidaysComponent } from './pages/holidays/holidays/holidays.component';
import { BenefitsEditComponent } from './pages/benefits/benefits-edit/benefits-edit.component';
import { ParametersViewComponent } from './pages/parameters/parameters-view/parameters-view.component';
import { PositionsDetailComponent } from './pages/positions/positions-detail/positions-detail.component';
import { AreasDetailComponent } from './pages/areas/areas-detail/areas-detail.component';
import { DivisionsDetailComponent } from './pages/divisions/divisions-detail/divisions-detail.component';
import { EmployDetailComponent } from './pages/employ/employ-detail/employ-detail.component';
import { BenefitsCatalogComponent } from './pages/benefit-catalog/benefits-catalog/benefits-catalog.component';
import { BenefitCatalogEditComponent } from './pages/benefit-catalog/benefits-catalog-edit/benefits-catalog-edit.component';
import { CompanyAddComponent } from './pages/companies/company-add/company-add.component';
import { SubscriptionComponent } from './pages/subscriptions/subscription/subscription.component';
import { SubscriptionEditComponent } from './pages/subscriptions/subscription-edit/subscription-edit.component';
import { CompanyAdminModule } from './pages/company-admin/company-admin.module';
import { CompanyAdminComponent } from './pages/company-admin/company-admin/company-admin.component';
import { WithholdingsAddComponent } from './pages/withholdings/withholdings-add/withholdings-add.component';
import { WithholdingsComponent } from './pages/withholdings/withholdings/withholdings.component';
import { CostPerEmployeesComponent } from './pages/cost-per-employees/cost-per-employees/cost-per-employees.component';
import { CostPerEmployeesAddComponent } from './pages/cost-per-employees/cost-per-employees-add/cost-per-employees-add.component';
import { CostPerEmployeeAddComponent } from './pages/cost-per-employee-catalog/cost-per-employee-add/cost-per-employee-add.component';
import { CostPerEmployeeComponent } from './pages/cost-per-employee-catalog/cost-per-employee/cost-per-employee.component';
import { WithholdingComponent } from './pages/withholding-catalog/withholding/withholding.component';
import { WithholdingAddComponent } from './pages/withholding-catalog/withholding-add/withholding-add.component';
import { FormulasAddComponent } from './pages/formulas/formulas-add/formulas-add.component';
import { FormulasComponent } from './pages/formulas/formulas/formulas.component';
import { VariableComponent } from './pages/variable-catalog/variable/variable.component';
import { VariableAddComponent } from './pages/variable-catalog/variable-add/variable-add.component';
import { ObjectComponent } from './pages/object-catalog/object/object.component';
import { ObjectAddComponent } from './pages/object-catalog/object-add/object-add.component';
import { FormulaEvaluatorComponent } from './pages/offer-formula-evaluator/formula-evaluator/formula-evaluator.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: "full",
    redirectTo: "login" // "susbscriptions"
  },//##################################################################################
  {
    path: 'login',
    component: LogginComponent
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent
  },
  {
    path: 'offers',
    component: OffersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'offers/create', 
    component: OffersAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'offers/edit/:id',
    component: OffersAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'employee',
    component: EmployComponent,
    canActivate: [authGuard]
  },
  {
    path: 'employee/detail/:id',
    component: EmployDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users',
    component: UserComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/create', 
    component: UserAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/edit/:id',
    component: UserAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'areas',
    component: AreasComponent,
    canActivate: [authGuard]
  },
  {
    path: 'areas/edit/:id',
    component: AreasDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'areas/create',
    component: AreasDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsGroup',
    component: BenefitsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsGroup/edit/:id',
    component: BenefitsEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsGroup/create',
    component: BenefitsEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'divisions',
    component: DivisionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'divisions/edit/:id',
    component: DivisionsDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'divisions/create',
    component: DivisionsDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'positions',
    component: PositionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'positions/edit/:id',
    component: PositionsDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'parameters',
    component: ParametersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'parameters/edit/:id',
    component: ParametersViewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'signatures',
    component: SignaturesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'signatures/edit/:id',
    component: SignaturEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'signatures/create',
    component: SignaturEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'reset-password',
    component: PasswordResetComponent
  },
  {
    path: 'recovery-password/:token',
    component: PasswordRecoveryComponent
  }
  /*
  {
    path: 'users/page/:page/:pageSize',
    component: UserAdminComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/edit/:id',
    component: UserFormComponent,
    canActivate: [authGuard]
  },//##################################################################################
  */,
  {
    path: 'employee/upload',
    component: EmployUploadComponent, //FileUploadComponent,
    canActivate: [authGuard]
  },
  /*{
    path: 'employee/page/:page/:pageSize',
    component: EmployeeListComponent,
    canActivate: [authGuard]
  }*/
  
  {
    path: 'companies',
    component: CompaniesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'companies/add',
    component: CompanyAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'companies/edit/:id',
    component: CompanyAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'requestedSignatures',
    component: RequestedSignaturesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'requestedSignatures/review/:id',
    component: ReviewRequestedSignaturesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'budgetCalculation',
    component: BudgetCalculationComponent,
    canActivate: [authGuard]
  },
  {
    path: 'holidays',
    component: HolidaysComponent,
    canActivate: [authGuard]
  },
  {
    path: 'holidays/edit/:id',
    component: HolidaysEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'holidays/create',
    component: HolidaysEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsCatalog',
    component: BenefitsCatalogComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsCatalog/edit/:id',
    component: BenefitCatalogEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'benefitsCatalog/create',
    component: BenefitCatalogEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'susbscriptions',
    component: SubscriptionComponent
    //canActivate: [authGuard]
  },
  {
    path: 'susbscriptions/edit',
    component:SubscriptionEditComponent
    //canActivate: [authGuard]
  },{
    path: 'adminCompany',
    component: CompanyAdminComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsGroup',
    component: WithholdingsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsGroup/edit/:id',
    component: WithholdingsAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsGroup/create',
    component: WithholdingsAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeeGroup',
    component: CostPerEmployeesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeeGroup/edit/:id',
    component: CostPerEmployeesAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeeGroup/create',
    component: CostPerEmployeesAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeesCatalog',
    component: CostPerEmployeeComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeesCatalog/edit/:id',
    component: CostPerEmployeeAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'costsPerEmployeesCatalog/create',
    component: CostPerEmployeeAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsCatalog',
    component: WithholdingComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsCatalog/edit/:id',
    component: WithholdingAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'withholdingsCatalog/create',
    component: WithholdingAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'formulasGroup',
    component: FormulasComponent,
    canActivate: [authGuard]
  },
  {
    path: 'formulasGroup/edit/:id',
    component: FormulasAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'formulasGroup/create',
    component: FormulasAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'variablesCatalog',
    component: VariableComponent,
    canActivate: [authGuard]
  },
  {
    path: 'variablesCatalog/edit/:id',
    component: VariableAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'variablesCatalog/create',
    component: VariableAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'objectsCatalog',
    component: ObjectComponent,
    canActivate: [authGuard]
  },
  {
    path: 'objectsCatalog/edit/:id',
    component: ObjectAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'objectsCatalog/create',
    component: ObjectAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'formulaEvaluator/:id',
    component: FormulaEvaluatorComponent,
    canActivate: [authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
